module.exports = __webpack_public_path__ + "HelveticaBoldOblique.9f5e45568665a27d522a.woff2";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/Helvetica/HelveticaBoldOblique.woff2
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaBoldOblique.woff2
// module chunks = styles